import React from 'react';
import { Link } from 'react-router-dom';
import './About.css'; // This is the only additional file needed

const About = () => {
  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-content">
          <h1>About GN Constructors</h1>
          <p className="subtitle">Building Excellence Since 2010</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <h2>Our Mission</h2>
          <p className="mission-statement">
            We deliver exceptional construction services by combining innovative engineering with 
            time-honored craftsmanship. Our mission is to build spaces that inspire while maintaining 
            uncompromising standards of quality and safety.
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🏗️</div>
              <h3>Quality</h3>
              <p>We use premium materials and proven techniques to ensure lasting results.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Integrity</h3>
              <p>Honest communication and transparent pricing on every project.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🔧</div>
              <h3>Innovation</h3>
              <p>We embrace new technologies that improve efficiency and sustainability.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section - Replaced Team Section */}
      <section className="process-section">
        <div className="container">
          <h2>Our Proven Construction Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Discovery & Planning</h3>
                <p>We begin with in-depth consultations to understand your vision, followed by comprehensive feasibility studies and project planning.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Design Development</h3>
                <p>Our architects and engineers collaborate to create designs that balance aesthetics, functionality, and budget considerations.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Precision Execution</h3>
                <p>With approved plans, our skilled craftsmen bring the project to life, maintaining rigorous quality control at every stage.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Final Review</h3>
                <p>We conduct thorough inspections and walkthroughs to ensure complete satisfaction before handing over your completed project.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat">
              <h3>15+</h3>
              <p>Years in Business</p>
            </div>
            <div className="stat">
              <h3>500+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat">
              <h3>98%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Build Your Vision?</h2>
          <Link to="/contact" className="about-button">
            Get a Free Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;